import { render } from "./HistoryTasksModal.vue?vue&type=template&id=6dcab778"
import script from "./HistoryTasksModal.vue?vue&type=script&lang=js"
export * from "./HistoryTasksModal.vue?vue&type=script&lang=js"

import "./HistoryTasksModal.vue?vue&type=style&index=0&id=6dcab778&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__